skrilla.controller('loginCtrl', function ($scope, loginService) {
    $scope.login = function () {
        loginService.login($scope.loginDetails);
    }
    $scope.btnPress = function (keyEvent) {
        if (keyEvent.which === 13)
            $scope.login();
    }
});

